const EkaScribeWithSDKDemo = () => {
    return (
        <div>
            <iframe
                src="/eka-scribe-staticUI/build/index.html"
                style={{ width: '100%', height: '100vh', border: 'none' }}
                title="Eka SDK Demo"
            />
        </div>
    );
};

export default EkaScribeWithSDKDemo;
